import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=27a800c0&"
import script from "./DashboardItem.vue?vue&type=script&lang=js&"
export * from "./DashboardItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports